import axios from 'axios';
import { getApiUrl } from '../config/api';

// Get API base URL from config (loads from .env file)
const API_BASE_URL = getApiUrl();

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Assessment API calls
export const assessmentAPI = {
  // Submit a new assessment
  createAssessment: async (assessmentData) => {
    try {
      const response = await apiClient.post('/assessments', assessmentData);
      return response.data;
    } catch (error) {
      console.error('Error creating assessment:', error);
      throw error.response?.data || error.message;
    }
  },

  // Get all assessments
  getAllAssessments: async (params = {}) => {
    try {
      const response = await apiClient.get('/assessments', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching assessments:', error);
      throw error.response?.data || error.message;
    }
  },

  // Get assessment by ID
  getAssessmentById: async (id) => {
    try {
      const response = await apiClient.get(`/assessments/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching assessment:', error);
      throw error.response?.data || error.message;
    }
  },

  // Delete assessment
  deleteAssessment: async (id, updatedBy) => {
    try {
      const response = await apiClient.delete(`/assessments/${id}`, {
        data: { updatedBy }
      });
      return response.data;
    } catch (error) {
      console.error('Error deleting assessment:', error);
      throw error.response?.data || error.message;
    }
  },
};

// Question API calls
export const questionAPI = {
  // Get all questions
  getAllQuestions: async (params = {}) => {
    try {
      const response = await apiClient.get('/questions', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching questions:', error);
      throw error.response?.data || error.message;
    }
  },

  // Seed questions (initial setup)
  seedQuestions: async () => {
    try {
      const response = await apiClient.post('/questions/seed');
      return response.data;
    } catch (error) {
      console.error('Error seeding questions:', error);
      throw error.response?.data || error.message;
    }
  },
};

export default apiClient;

